import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";
import { useCorreosElectronicosContext } from "../correos-electronicos-context";

export function CorreosElectronicosTable() {
  const navigate = useNavigate();

  const {
    correosElectronicos,
    deleteCorreoElectronico,
    verifyCorreoElectronico,
  } = useCorreosElectronicosContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">
              Direcciones de correo electrónico
            </Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!correosElectronicos.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Dirección de correo electrónico",
                  // "Estado",
                  // "Opciones",
                ].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {correosElectronicos.map((correo, index) => (
                <TableRow key={correo.correo_electronico_id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        <a
                          href={`mailto:${correo.correo_electronico_direccion}`}
                        >
                          {correo.correo_electronico_direccion}
                        </a>
                      </Typography>

                      {!!correo.correo_electronico_principal && (
                        <Chip
                          label="Principal"
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      )}
                    </Stack>
                  </TableCell>

                  {/* <TableCell>
                    <Chip
                      label={
                        !!correo.correo_electronico_verificado
                          ? "Verificada"
                          : "Pendiente"
                      }
                      color={
                        !!correo.correo_electronico_verificado
                          ? "success"
                          : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {!correo.correo_electronico_verificado ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyCorreoElectronico({
                                correoElectronicoId:
                                  correo.correo_electronico_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(`${correo.correo_electronico_id}/edit`, {
                                replace: true,
                              })
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () => {
                              await deleteCorreoElectronico({
                                correoElectronicoId:
                                  correo.correo_electronico_id,
                              });
                            }}
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin direcciones de correo electrónico
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
